import {getStartOfWeek} from '@igp/shared/utils';

export const lastUpdatedItemId = 'lastUpdatedItemId';

export const DebtTransferLogServiceTypes = {
    downloadClientStrategy: Symbol('DebtTransferLogDownloadClientStrategy'),
    downloadServerStrategy: Symbol('DebtTransferLogDownloadServerStrategy'),
    service: Symbol('DebtTransferLogService'),
    epicsBuilder: Symbol('DebtTransferLogEpicsBuilder'),
} as const;

export const DebtTransferLogTypeName = 'DebtTransferLog';
export const DebtTransferLogViewModelTypeName = 'DebtTransferLogViewModel';
export const DebtTransferLogDownloadModelTypeName = 'DebtTransferLogDownloadModel';
export const DebtTransferLogViewModelKeysTypeName = 'DebtTransferLogViewModelKeys';
export const DebtTransferLogQueryFieldsTypeName = 'DebtTransferLogQueryFields';
export const DebtTransferLogDownloadFieldsTypeName = 'DebtTransferLogDownloadFields';
export const DebtTransferLogSortKeysTypeName = 'DebtTransferLogSortKeys';
export const AdjustDebtFormModelTypeName = 'AdjustDebtFormModel';
export const AdjustAgentDebtInputTypeName = 'AdjustAgentDebtInput';

const availableWeekCount = 14; // ~ 3 months
export const firstAvailableDate = getStartOfWeek(availableWeekCount);
